//eslint-disable-next-line max-len
export const emailRegex = /^((([a-z]|\d|[!#\$%&\*\+\-\?_])+(\.([a-z]|\d|[!#\$%&\*\+\-\?_])*)*)*)@((([a-z]|\d)|(([a-z]|\d)([a-z]|\d|-|\.|_)*([a-z]|\d)))\.)+(([a-z])|(([a-z])([a-z]|\d|-|\.|_)*([a-z])))$/i;

/**
 * Check isEmptyString prior to calling this function
 * This function will return an empty string if passed an empty string
 * Takes regex from checkout-widget/src-widget/src/common/vco-component-identification/helpers/is-email.js
 * @param {String} inputString
 * @returns {Boolean}
 */
const isEmail = inputString => {
  return emailRegex.test(inputString);
};

export default isEmail;
